<template>
  <span class="healing-markers">
    <Button v-uEdition="'YZ-36'" :disabled="!courseImproveInfo.pdcId" v-bind="buttonProps" class="ubtn_icon"
      size="small" @click="openWin" icon="md-checkmark-circle-outline" type="success"
      :ghost="!courseImproveInfo.isImprove">标记病程好转</Button>
    <Modal v-model="showWin" :title="courseImproveInfo.isImprove ? '取消病程好转标记' : '标记患者病程好转'" @on-cancel="cancel"
      footer-hide width="500">
      <div class="healing-markers-modal2">
        <div class="content2" v-if="courseImproveInfo.isImprove">
          <div class="title">确定要取消该患者的病程好转标记吗？</div>
          <div class="red-tip">取消后，患者将不再满足购买最佳诊疗方案的好转条件，相关标记信息也会从页面移除。</div>
        </div>
        <div class="content" v-else>
          <div class="info">
            <div class="title"><strong>重要说明</strong></div>
            <div class="tip">
              <span>标记患者在最近病程好转，此标记</span>
              <strong>仅作为患者能够购买最佳诊疗方案的好转条件</strong>，
              <span>用于判定患者是否满足购买最佳诊疗方案的资格。<strong>该标记不是回访好转记录</strong>，</span>
              <span>不代表对患者疗效的正式回访评估，请勿与回访好转混淆。</span>
            </div>
          </div>
          <div class="header">
            <div class="title"><strong>患者信息</strong></div>
            <div class="patient-info">
              <span class="patient-name">{{ info.patientName }}</span>
              <span v-if="info.sex">{{ info.sex }}</span>
              <span v-if="info.patientAge !== null">{{ info.patientAge }}岁</span>
              <span>{{ info.cellphoneNo }}</span>
            </div>
          </div>
        </div>
        <div class="btn-group">
          <Button @click="showWin = false">再想想</Button>
          <Button :type="courseImproveInfo.isImprove ? 'error' : 'success'" @click="submit">{{
            courseImproveInfo.isImprove ? '确认取消' : '确认标记好转' }}</Button>
        </div>
      </div>
    </Modal>
  </span>
</template>

<script>
import request from "@/utils/request";
import { mapGetters } from "vuex";
export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    buttonProps: {
      type: Object,
      default: () => ({
        icon: "md-pricetag",
        shape: "circle"
      }),
    },
    keyStr: {
      type: String,
      default: "markGood"
    },
    isDetail: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["indexSpin"]),
  },
  watch: {
    info() {
      this.init();
    }
  },
  data() {
    return {
      showWin: false,
      courseImproveInfo: {
        "improveDate": null,
        "isImprove": 0,
        "pdcId": null,
      },
    };
  },
  methods: {
    cancel() {
      this.showWin = false;
    },
    openWin() {
      this.showWin = true;
    },
    getData() {
      if (!this.info.patientCode) return;
      request
        .post("/saascashier/getYzCourseImproveInfo", {
          patientCode: this.info.patientCode,
        })
        .then((res) => {
          this.courseImproveInfo = res.result;
          this.$bus.emit(this.keyStr, res.result.improveDate);
        });
    },
    submit() {
      request
        .post("/saascashier/updateYzCourseImproveInfo", {
          pdcId: this.courseImproveInfo.pdcId,
          isImprove: this.courseImproveInfo.isImprove ? 0 : 1,
        })
        .then((res) => {
          this.showWin = false;
          this.$Message.success(res.result);
          this.getData();
          if (this.isDetail) {
            // 更新就诊页信息
            this.$bus.emit("markGoodRefresh");
          }
        });
    },
    refresh() {
      this.getData();
    },
    init() {
      this.courseImproveInfo = {
        "improveDate": null,
        "isImprove": 0,
      };
      this.getData();
    }
  },
  mounted() {
    this.init();
    if (!this.isDetail) {
      this.$bus.on("markGoodRefresh", this.refresh);
    }
  },
  beforeDestroy() {
    if (!this.isDetail) {
      this.$bus.off("markGoodRefresh", this.refresh);
    }
  },
};
</script>

<style lang="scss" scoped>
.healing-markers {}
</style>
<style lang="scss">
.healing-markers-modal2 {
  .content2 {
    padding: 20px 0 30px;

    .red-tip {
      color: red;
    }
  }

  .info {
    padding: 10px 15px;
    background: #fef9e7;
    border-radius: 5px;
    border-left: 3px solid #b7950b;
    margin-bottom: 15px;
    color: #7e6607;

    strong {
      color: #b7950b;
    }
  }

  .title {
    font-size: 16px;
    margin-bottom: 10px;
  }

  .patient-info {
    padding: 10px 15px;
    border-radius: 5px;
    background: #f5f5f5;

    &>span {
      margin-right: 15px;
    }
  }

  .header {
    margin-bottom: 20px;
  }

  .btn-group {
    text-align: right;
  }

  .ivu-btn {
    +.ivu-btn {
      margin-left: 10px;
    }
  }

}
</style>